import { Target, Lightning, Envelope, ChartBar, DownloadSimple } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StatsBar({ stats }) {
  const handleExportCSV = () => {
    window.open(`${API}/export/csv`, "_blank");
  };

  return (
    <div className="border-b border-[--border] bg-white" data-testid="stats-bar">
      <div className="flex items-center divide-x divide-[--border]">
        <Stat icon={Target} label="Prospects" value={stats.total_prospects} />
        <Stat icon={Lightning} label="Audited" value={stats.audited} color="var(--success)" />
        <Stat icon={Envelope} label="Emails" value={stats.emails_generated} color="var(--primary)" />
        <Stat icon={ChartBar} label="Avg Score" value={stats.avg_score ? `${stats.avg_score}` : "—"} color="var(--warning)" />
        <div className="flex items-center px-4">
          <button
            data-testid="export-csv-btn"
            onClick={handleExportCSV}
            disabled={stats.total_prospects === 0}
            className="flex items-center gap-1.5 px-4 py-1.5 text-xs font-medium border border-[--border] text-[--text-secondary] hover:bg-[--primary] hover:text-white hover:border-[--primary] transition-all active:scale-95 disabled:opacity-30 disabled:cursor-not-allowed"
          >
            <DownloadSimple size={14} weight="bold" />
            Export CSV
          </button>
        </div>
      </div>
    </div>
  );
}

function Stat({ icon: Icon, label, value, color }) {
  return (
    <div className="flex-1 flex items-center gap-3 px-5 py-3">
      <Icon size={18} weight="duotone" style={{ color: color || "var(--text-secondary)" }} />
      <div>
        <p className="text-xs text-[--text-muted] uppercase tracking-wider font-medium">{label}</p>
        <p className="text-lg font-bold text-[--text-primary] leading-none mt-0.5">{value}</p>
      </div>
    </div>
  );
}
